
/* eslint-disable camelcase */
import React, { useEffect, useState, FC } from 'react'
import empty from '../../../../Assets/images/user-empty-avatar.png'
import { Link } from 'react-router-dom'
import applicantsService from '../../../../Services/applicantsService'
import Pagination from '../../../../Components/Pagination/Pagination'
import { Loader } from '../../../../Components'
import './Applicants.scss'
import { ErrorHandler } from '../../../../Helpers/ErrorHandler'
import toast, { Toaster } from 'react-hot-toast'
interface userType {
  birthcountry: string,
  birthdate: string,
  birthlga: string,
  birthstate: string,
  centralID: string,
  educationallevel: string,
  email: string,
  emplymentstatus: string,
  firstname: string,
  gender: string,
  heigth: string,
  maritalstatus: string,
  middlename: string,
  nin: string,
  nok_address1: string,
  nok_address2: string,
  nok_firstname: string,
  nok_lga: string,
  nok_middlename: string,
  nok_state: string,
  nok_surname: string,
  nok_town: string,
  nspokenlang: string,
  ospokenlang: string,
  pfirstname: string,
  pmiddlename: string,
  profession: string,
  psurname: string,
  religion: string,
  residence_AdressLine1: string,
  residence_Town: string,
  residence_lga: string,
  residence_state: string,
  residencestatus: string,
  self_origin_lga: string,
  self_origin_place: string,
  self_origin_state: string,
  surname: string,
  telephoneno: string,
  title: string,
  trackingId: string

}

const Applicants:FC = () => {
  // eslint-disable-next-line no-unused-vars
  const [activeUSer, setActiveUSer] = useState<userType>({
    birthcountry: '',
    birthdate: '',
    birthlga: '',
    birthstate: '',
    centralID: '',
    educationallevel: '',
    email: '',
    emplymentstatus: '',
    firstname: '',
    gender: '',
    heigth: '',
    maritalstatus: '',
    middlename: '',
    nin: '',
    nok_address1: '',
    nok_address2: '',
    nok_firstname: '',
    nok_lga: '',
    nok_middlename: '',
    nok_state: '',
    nok_surname: '',
    nok_town: '',
    nspokenlang: '',
    ospokenlang: '',
    pfirstname: '',
    pmiddlename: '',
    profession: '',
    psurname: '',
    religion: '',
    residence_AdressLine1: '',
    residence_Town: '',
    residence_lga: '',
    residence_state: '',
    residencestatus: '',
    self_origin_lga: '',
    self_origin_place: '',
    self_origin_state: '',
    surname: '',
    telephoneno: '',
    title: '',
    trackingId: ''
  })
  const [page, setPage] = useState(1)
  // eslint-disable-next-line no-unused-vars
  const [resultPerPage, setResultPerPage] = useState(20)
  // eslint-disable-next-line no-unused-vars
  const [filter, setFilter] = useState('all')
  const [applicant, setApplicant] = useState<any[]>([])
  const [loader, setLoader] = useState(false)

  const getList = async () => {
    setLoader(true)
    await applicantsService.getAllDataAx(page, resultPerPage, filter)
      .then(res => {
        setLoader(false)
        console.log('ALists result', res.data)
        setApplicant(res.data.resultSet)
      }, (e) => {
        setLoader(false)
        console.log('AList error', e.response)
        ErrorHandler(e,
          () => {
            toast.error(e?.response?.data?.message, { duration: 20000, className: 'bg-danger text-white' })
          })
      })
  }

  useEffect(() => {
    getList()
  }, [page, resultPerPage, filter])

  console.log('applicant 000', applicant)
  return (
    <div className='applicants'>
      <div className="container-fluid px-4">
        {/* Header Section */}
        <div className="applicants-header">
          <div className="breadcrumb-section">
            <Link to="/dashboard" className="breadcrumb-link">
              <i className='fa fa-home'></i> Dashboard
            </Link>
            <span className='breadcrumb-separator'>/</span>
            <span className="breadcrumb-current">All Applicants</span>
          </div>

          <div className="header-content">
            <div className="header-title-section">
              <h1 className="page-title">Applicants</h1>
              <p className="page-subtitle">Manage and screen all applicants</p>
            </div>

            <div className="header-stats">
              <div className="stat-card">
                <div className="stat-icon bg-primary">
                  <i className="fa fa-users"></i>
                </div>
                <div className="stat-content">
                  <div className="stat-value">{applicant.length}</div>
                  <div className="stat-label">Total Applicants</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div className="applicants-card">
          <div className="card-header-custom">
            <div className="header-left">
              <h2 className="card-title">Applicant List</h2>
            </div>
            <div className="header-right">
              <div className="search-box">
                <i className="fa fa-search"></i>
                <input type="text" placeholder="Search applicants..." className="search-input" />
              </div>
            </div>
          </div>

          <div className="card-body-custom">
            <div className='table-responsive'>
              <table className="modern-table">
                <thead>
                  <tr>
                    <th className="checkbox-col">
                      <input type="checkbox" className="modern-checkbox" />
                    </th>
                    <th className="avatar-col"></th>
                    <th>Applicant</th>
                    <th>Contact</th>
                    <th>Location</th>
                    <th>Gender</th>
                    {/* <th>Education</th> */}
                    <th className="action-col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {applicant.length > 0 && applicant.map((res: any, index) => {
                    const { firstname, surname, nin, email, stateOfPermanent, phone, lgaOfPermanent, gender } = res.dataset.formData
                    return (
                      <tr key={index} className='table-row'>
                        <td className="checkbox-col">
                          <input type="checkbox" className="modern-checkbox" />
                        </td>
                        <td className="avatar-col">
                          <div className="avatar-wrapper">
                            <img src={empty} alt={`${firstname} ${surname}`} className='applicant-avatar' />
                          </div>
                        </td>
                        <td>
                          <div className="applicant-info">
                            <div className="applicant-name">{firstname} {surname}</div>
                            <div className="applicant-email">{email}</div>
                          </div>
                        </td>
                        <td>
                          <div className="contact-info">
                            <i className="fa fa-phone contact-icon"></i>
                            {phone}
                          </div>
                        </td>
                        <td>
                          <div className="location-info">
                            <div className="location-state">{stateOfPermanent}</div>
                            <div className="location-lga">{lgaOfPermanent}</div>
                          </div>
                        </td>
                        <td>
                          <span className={`gender-badge ${gender === 'f' ? 'female' : 'male'}`}>
                            {gender === 'f' ? 'Female' : 'Male'}
                          </span>
                        </td>
                        {/* <td>
                          <span className="education-level">{educationallevel}</span>
                        </td> */}
                        <td className="action-col">
                          <Link to={`/automatedapplicant/${nin}`}>
                            <button className="screen-button">
                              <i className="fa fa-user-check"></i>
                              Screen
                            </button>
                          </Link>
                        </td>
                      </tr>
                    )
                  })}
                  {applicant.length === 0 && loader === false && (
                    <tr className='empty-row'>
                      <td colSpan={8}>
                        <div className='empty-state'>
                          <i className="fa fa-users empty-icon"></i>
                          <h3>No Applicants Found</h3>
                          <p>There are no applicants at this stage</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="table-footer">
              <div className="results-info">
                Showing {applicant.length} of 1000 applicants
              </div>
              <Pagination
                className="modern-pagination"
                currentPage={page}
                totalCount={1000}
                pageSize={resultPerPage}
                onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
              />
            </div>
          </div>
        </div>
      </div>

      <Loader show={loader}></Loader>
      <Toaster></Toaster>
    </div>
  )
}

export default Applicants
